import React from 'react';
import * as S from './HotelInfoLoader.styles';

const HotelInfoLoader = () => {
  return (
    <S.HotelInfoLoader>
      <S.HeaderWithIconWrap>
        <S.HotelInfoHeader></S.HotelInfoHeader>
        <S.ArrowDownWrap>
          <S.ArrowDown></S.ArrowDown>
        </S.ArrowDownWrap>
      </S.HeaderWithIconWrap>

      <S.HotelInfoOuterWrap>
        <S.ImageContainer></S.ImageContainer>
        <S.HotelDetailsWrap>
          <S.HotelNameLoader></S.HotelNameLoader>
          <S.HotelLocationLoader></S.HotelLocationLoader>
          <S.HotelRatingLoader></S.HotelRatingLoader>
          <S.CheckingOuterWrap>
            <S.CheckinCheckoutWrap>
              <S.CheckInTitle></S.CheckInTitle>
              <S.CheckInDay></S.CheckInDay>
              <S.CheckInTime></S.CheckInTime>
            </S.CheckinCheckoutWrap>

            <S.CheckinCheckoutWrap>
              <S.CheckInTitle></S.CheckInTitle>
              <S.CheckInDay></S.CheckInDay>
              <S.CheckInTime></S.CheckInTime>
            </S.CheckinCheckoutWrap>

            <S.CheckinCheckoutWrap>
              <S.CheckInTitle></S.CheckInTitle>
              <S.CheckInDay></S.CheckInDay>
              <S.CheckInTime></S.CheckInTime>
            </S.CheckinCheckoutWrap>
          </S.CheckingOuterWrap>
        </S.HotelDetailsWrap>
      </S.HotelInfoOuterWrap>


      <S.RoomTitleOuterWrap>
        <S.RoomTitleWrap></S.RoomTitleWrap>
        <S.RoomInclusionsWrap></S.RoomInclusionsWrap>
        <S.RoomInclusionsWrap></S.RoomInclusionsWrap>
      </S.RoomTitleOuterWrap>
    </S.HotelInfoLoader>
  );
};

export default HotelInfoLoader;
